import React from "react";
import { Info, X } from "lucide-react";
import { sanitizedHtml } from "../../utils/sanitize";

const COOKIE_KEY = "announcements";

function readDismissed() {
  try {
    const raw = document.cookie
      .split("; ")
      .find((c) => c.startsWith(COOKIE_KEY + "="));
    if (!raw) return {};
    return JSON.parse(decodeURIComponent(raw.split("=")[1]));
  } catch {
    return {};
  }
}

function writeDismissed(dismissed) {
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(JSON.stringify(dismissed))}; path=/; max-age=${60 * 60 * 24 * 365}`;
}

function Announcement({ announcement, onDismiss }) {
  const title = announcement.title?.rendered || announcement.title;

  return (
    <div className="announcement">
      <Info className="announcement-icon" size={20} strokeWidth={2} />
      <div className="note">
        {announcement.link ? (
          <a
            href={announcement.link}
            target="_blank"
            rel="noopener noreferrer"
            dangerouslySetInnerHTML={sanitizedHtml(title)}
          />
        ) : (
          <span dangerouslySetInnerHTML={sanitizedHtml(title)} />
        )}
      </div>
      <button
        className="close"
        type="button"
        onClick={() => onDismiss(announcement.ID || announcement.id)}
        aria-label="Dismiss"
      >
        <X size={20} strokeWidth={2} />
      </button>
    </div>
  );
}

function Announcements({ announcements = [] }) {
  const [dismissed, setDismissed] = React.useState(readDismissed);

  const visible = announcements.filter(
    (a) => !dismissed[a.ID || a.id]?.dismissedOn
  );

  function handleDismiss(id) {
    const next = {
      ...dismissed,
      [id]: { dismissedOn: new Date().toISOString() },
    };
    setDismissed(next);
    writeDismissed(next);
  }

  if (visible.length === 0) return null;

  return (
    <div className="announcements">
      {visible.map((a, idx) => (
        <Announcement
          key={a.ID || a.id || idx}
          announcement={a}
          onDismiss={handleDismiss}
        />
      ))}
    </div>
  );
}

export default Announcements;
